
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import PositionTable from '../components/PositionTable';

const Position = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    
    navigate('/position/add');
  };

  

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Position Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Position
        </button>
      </div>

      <PositionTable />
    </div>
  );
};

export default Position;